import { NgModule } from "@angular/core";
import {EntityPageBaseComponent} from "./entity-page-base.component";
@NgModule({
    declarations: [
        EntityPageBaseComponent,
    ],
    imports: [

    ],
    exports:[
        EntityPageBaseComponent
    ]
})
export class EntityPageWrapperModule {}
